// extracted by mini-css-extract-plugin
export var container = "_ko-0";
export var dotAnimation = "_ko-2";
export var dotsLoading = "_ko-1";